import script from "./chemicalControl.vue?vue&type=script&setup=true&lang=js"
export * from "./chemicalControl.vue?vue&type=script&setup=true&lang=js"

import "./chemicalControl.vue?vue&type=style&index=0&id=16287e01&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16287e01"]])

export default __exports__